import { BASIC_CATALOG_REFERENCE } from "../../../ui/a2ui/types.js";

export function executeListComponents(): string {
  return BASIC_CATALOG_REFERENCE;
}
